export interface ContactFormPageCaseReason {
  value: string;
  label: string;
}

export interface BaseContactFormDetails {
  caseReason: string;
  description: string;
  attachments: readonly File[];
  phoneNumber: string;
  emailAddress: string;
  preferredContactForm: string;
}

export interface ContactFormRequest extends BaseContactFormDetails {
  fullName: string;
  streetAddress: string;
  zipCode: string;
  city: string;
  personalIdentityNumber: string;
}

export interface FileUploadEvent {
  target: {
    files: File[];
  };
}

export interface ClickEvent {
  target: {
    value: string;
  };
}

export interface AuthenticationResponse {
  token: string;
}

export interface CollectStatusResponse extends AuthenticationResponse {
  status: string;
}

export interface User {
  name: string;
  givenName: string;
  surname: string;
  personalNumber: number;
  uuid: string;
}

export enum Properties {
  CaseReason = 'caseReason',
  Description = 'description',
  Attachments = 'attachments',
  FullName = 'fullName',
  StreetAddress ='streetAddress',
  ZipCode = 'zipCode',
  City = 'city',
  PhoneNumber = 'phoneNumber',
  EmailAddress = 'emailAddress',
  PersonalIdentityNumber = 'personalIdentityNumber',
  PreferredContactForm = 'preferredContactForm',

  RequestAuthentication = 'requestAuthentication',
  IsAuthenticated = 'isAuthenticated',
  IsAuthenticationOngoing = 'isAuthenticationOngoing',
  AuthenticationError = 'authenticationError',
  AuthenticationWarning = 'authenticationWarning',
  Authenticate = 'authenticate',
  CancelAuthentication = 'cancelAuthentication',
  IsCancellationOngoing = 'isCancellationOngoing',

  CollectStatus = 'collectStatus',
  EndSession = 'endSession',
  FetchUser = 'fetchUser',
  Init = 'init',
  Token = 'token',
}

export const VALIDATION_MESSAGES: Record<string, string> = {
  [Properties.CaseReason]: 'Vänligen välj ett ärende',
  [Properties.Description]: 'Vänligen beskriv ditt ärende',
  [Properties.FullName]: 'Vänligen ange fullständigt namn',
  [Properties.StreetAddress]: 'Vänligen ange gatuadress dit ärendet gäller',
  [Properties.ZipCode]: 'Vänligen ange Postnummer',
  [Properties.City]: 'Vänligen ange postort',
  [Properties.PhoneNumber]: 'Vänligen ange telefonnummer med landsnummer ex. +46',
  [Properties.EmailAddress]: 'Vänligen ange epost i rätt format',
  [Properties.Attachments]: 'Bifogad fil överstiger maximal filstorlek (25 MB)'
}

export const ACCEPTABLE_FILE_EXTENSIONS = [
  '.doc',
  '.docx',
  '.odt',
  '.pdf',
  '.xls',
  '.xlsx',
  '.ods',
  '.ppt',
  '.pptx',
  '.txt',
  '.jpg',
  '.jpeg',
  '.png',
  '.odp'
]

export enum PreferredContactFormEnum {
  Email = 'EMAIL',
  Phone = 'PHONE'
}
